export default __webpack_public_path__ + "static/media/mobile_dark_red.260a3213.svg";